<template>
  <div id="app">
    <Question />
  </div>
</template>

<script>
import Question from './components/Question.vue';

export default {
  components: {
    Question
  }
}
</script>
